export enum Orientation {
    Portrait,
    Landscape,
}

export enum Device {
    Mobile = 0,
    Tablet = 1,
    Laptop = 2,
    Desktop = 3,
}

export interface IResolutions {
    mobile: number;
    tablet: number;
    laptop: number;
}

export interface IViewportInfo {
    device: Device;
    isMobile: boolean;
    isTablet: boolean;
    isLaptop: boolean;
    isDesktop: boolean;
    isMobileOrTablet: boolean;
}

export const DefaultResolutions: IResolutions = {
    mobile: 760,
    tablet: 990,
    laptop: 1240,
};

export const calculateViewport = (innerWidth: number) => {
    const isMobile = innerWidth < DefaultResolutions.mobile;
    const isTablet = !isMobile && innerWidth < DefaultResolutions.tablet;
    const isLaptop = !isMobile && !isTablet && innerWidth < DefaultResolutions.laptop;
    const isDesktop = !isMobile && !isTablet && !isLaptop;
    const isMobileOrTablet = isMobile || isTablet;

    let device: Device;

    switch (true) {
        case isMobile:
            device = Device.Mobile;
            break;
        case isTablet:
            device = Device.Tablet;
            break;
        case isLaptop:
            device = Device.Laptop;
            break;
        default:
            device = Device.Desktop;
    }

    const info: IViewportInfo = {
        device,
        isMobile,
        isTablet,
        isLaptop,
        isDesktop,
        isMobileOrTablet,
    };

    return info;
};
